<section class="section old-legacy-code-tile">

    <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>

    <div
        *ngIf="newsItem"
        class="complex__content-wrapper"
    >
        <div class="complex-news__inner-container">
            <h1 class="complex-news__title">{{ newsItem.title }}</h1>
            <div class="complex-news__top-container">
                <a href="/novosti/news" class="complex-news__back-link">
                    <span class="complex-news__back-link-icon"></span>
                    Вернуться к новостям
                </a>
                <span class="complex-news__date">{{ newsItem.createdAt | date: 'dd.MM.yyyy' }}</span>
            </div>
            <img class="complex-news__image" [src]="newsItem.preview.path"
                 [alt]="newsItem.title" fill>
            <div class="complex-news__complex-link-container" *ngIf="complexNews?.complexSlug">
                <a class="complex-news__complex-link"
                   href="/novostrojki/zhk/{{complexNews?.complexSlug}}">{{complexNews?.complexTitle}}</a>
            </div>
            <div
                class="complex-news__content js-mediator-article"
                [innerHTML]="newsItem.content"
            >
            </div>
            <div class="complex-news__share-container">
                <span class="complex-news__share-title">Поделиться</span>
                <div class="uSocial-Share"
                     data-type="share"
                     data-options="round,style1,default,absolute,horizontal,size32,counter0,nomobile,mobile_position_right"
                     data-social="vk,telegram,email" data-key="0"
                     style="display: block;"
                >
                </div>
            </div>
        </div>
    </div>
</section>
